import logoutRoute from '../libs/OAuth2/routes/logoutRoute';
import catchallToRootRoute from '../libs/Router/routes/catchallToRootRoute';

const onlyGuests = true;
const onlyLoggedIn = true;

export default [
  /* PUBLIC */
  {
    path: '/',
    name: 'home',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/pages/Public/Login'),
    meta: {
      layout: 'modal',
      guards: { onlyGuests },
    },
  },
  {
    path: '/password-reset/:email?',
    name: 'password-reset',
    component: () => import(/* webpackChunkName: "login" */ '../views/pages/Public/PasswordReset'),
    meta: {
      layout: 'modal',
    },
  },
  {
    path: '/password-reset/:email/change-password/:token',
    name: 'password-reset-change-password',
    component: () => import(/* webpackChunkName: "login" */ '../views/pages/Public/ResetPasswordChange'),
    meta: {
      layout: 'modal',
    },
  },

  {
    path: '/sign-up',
    name: 'sign-up',
    component: () => import(/* webpackChunkName: "sign-up" */ '../views/pages/Public/SignUp'),
    meta: {
      layout: 'modal',
      guards: { onlyGuests },
    },
  },
  {
    path: '/sign-up/success',
    name: 'sign-up.success',
    component: () => import(/* webpackChunkName: "sign-up" */ '../views/pages/Public/SignUp'),
    meta: {
      layout: 'modal',
      guards: { onlyGuests },
    },
  },
  {
    path: '/profile/:email/activate/:token',
    name: 'profile-activation',
    component: () => import(/* webpackChunkName: "activation" */ '../views/pages/Public/ActivationLanding'),
    meta: {
      layout: 'modal',
      guards: { onlyGuests },
    },
  },

  /* USER PROFILE */
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/pages/MyProfile/ShowMyProfile'),
    meta: {
      guards: { onlyLoggedIn },
    },
  },
  {
    path: '/profile/edit',
    name: 'profile.edit',
    component: () => import('../views/pages/MyProfile/EditMyProfile'),
    meta: {
      guards: { onlyLoggedIn },
    },
  },
  {
    path: '/profile/password',
    name: 'change-password',
    component: () => import('../views/pages/MyProfile/ChangeMyPassword'),
    meta: {
      guards: { onlyLoggedIn },
    },
  },

  /* DASHBOARD */
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/pages/Dashboard/MyDashboard'),
    meta: {
      guards: { onlyLoggedIn },
    },
  },

  /* CLUBS */
  {
    path: '/clubs',
    component: () => import('../libs/Router/components/InnerRouter'),
    children: [
      {
        path: '',
        name: 'clubs.list',
        component: () => import('../views/pages/Club/ListClubs'),
      },
      {
        path: 'list-mine',
        name: 'clubs.list-mine',
        component: () => import('../views/pages/Club/ListMyClubsAsCoach'),
        meta: {
          guards: { roles: ['coach'] },
        },
      },
      {
        path: 'new',
        name: 'clubs.new',
        component: () => import('../views/pages/Club/CreateClub'),
        meta: {
          guards: { roles: ['admin'] },
        },
      },
      {
        path: ':id',
        component: () => import('../views/pages/Club/ClubFrame'),
        children: [
          {
            path: '',
            name: 'clubs.show',
            component: () => import('../views/pages/Club/ShowClub'),
          },
          {
            path: 'holes',
            name: 'clubs.holes',
            component: () => import('../views/pages/Club/ShowClubHoles'),
          },
          {
            path: 'coaches',
            name: 'clubs.coaches',
            component: () => import('../views/pages/Club/ShowClubCoaches'),
            meta: {
              guards: { roles: ['admin'] },
            },
          },
          {
            path: 'edit',
            name: 'clubs.edit',
            component: () => import('../views/pages/Club/EditClub'),
            meta: {
              guards: { roles: ['admin'] },
            },
          },
        ],
      },
    ],
  },

  /* COACHES */
  {
    path: '/coaches',
    component: () => import('../libs/Router/components/InnerRouter'),
    children: [
      {
        path: '',
        name: 'coaches.list',
        component: () => import('../views/pages/Coach/ListCoaches'),
        meta: {
          guards: { roles: ['admin'] },
        },
      },
      {
        path: 'new',
        name: 'coaches.new',
        component: () => import('../views/pages/Coach/CreateCoach'),
        meta: {
          guards: { roles: ['admin'] },
        },
      },
      {
        path: ':id',
        component: () => import('../views/pages/Coach/CoachFrame'),
        children: [
          {
            path: '',
            name: 'coaches.show',
            component: () => import('../views/pages/Coach/ShowCoach'),
          },
          {
            path: 'edit',
            name: 'coaches.edit',
            component: () => import('../views/pages/Coach/EditCoach'),
            meta: {
              guards: { roles: ['admin'] },
            },
          },
        ],
      },
    ],
  },

  /* PARENTS */
  {
    path: '/parents',
    component: () => import('../libs/Router/components/InnerRouter'),
    children: [
      {
        path: '',
        name: 'parents.list',
        component: () => import('../views/pages/Parent/ListParents'),
        meta: {
          guards: { roles: ['admin'] },
        },
      },
      {
        path: 'new',
        name: 'parents.new',
        component: () => import('../views/pages/Parent/CreateParent'),
        meta: {
          guards: { roles: ['admin'] },
        },
      },
      {
        path: ':id',
        component: () => import('../views/pages/Parent/ParentFrame'),
        children: [
          {
            path: '',
            name: 'parents.show',
            component: () => import('../views/pages/Parent/ShowParent'),
          },
          {
            path: 'edit',
            name: 'parents.edit',
            component: () => import('../views/pages/Parent/EditParent'),
            meta: {
              guards: { roles: ['admin'] },
            },
          },
        ],
      },
    ],
  },

  /* PLAYERS */
  {
    path: '/players',
    component: () => import('../libs/Router/components/InnerRouter'),
    meta: {
      guards: { onlyLoggedIn },
    },
    children: [
      {
        path: '',
        name: 'players.list',
        component: () => import('../views/pages/Player/ListPlayers'),
        meta: {
          guards: { roles: ['admin', 'parent'] },
        },
      },
      {
        path: 'new',
        name: 'players.new',
        component: () => import('../views/pages/Player/CreatePlayer'),
        meta: {
          guards: { roles: ['admin', 'parent'] },
        },
      },
      {
        path: ':id',
        component: () => import('../views/pages/Player/PlayerFrame'),
        children: [
          {
            path: '',
            name: 'players.show',
            component: () => import('../views/pages/Player/ShowPlayer'),
          },
          {
            path: 'edit',
            name: 'players.edit',
            component: () => import('../views/pages/Player/EditPlayer'),
            meta: {
              guards: { roles: ['admin', 'parent'] },
            },
          },
        ],
      },
    ],
  },

  /* COMPETITIONS */
  {
    path: '/competitions',
    component: () => import('../libs/Router/components/InnerRouter'),
    children: [
      {
        path: '',
        name: 'competitions.list',
        component: () => import('../views/pages/Competition/ListCompetitions'),
      },
      {
        path: 'zones',
        name: 'competitions.zones',
        component: () => import('../views/pages/Competition/ListZones'),
      },
      {
        path: 'regions',
        name: 'competitions.regions',
        component: () => import('../views/pages/Competition/ListRegions'),
      },
      {
        path: 'new',
        name: 'competitions.new',
        component: () => import('../views/pages/Competition/CreateCompetition'),
        meta: {
          guards: { roles: ['admin', 'coach'] },
        },
      },
      {
        path: 'region/:id',
        name: 'competitions.region',
        component: () => import('../views/pages/Competition/ListRegionCompetitions'),
      },
      {
        path: 'zone/:id',
        name: 'competitions.zone',
        component: () => import('../views/pages/Competition/ListZoneCompetitions'),
      },
      {
        path: ':id',
        component: () => import('../views/pages/Competition/CompetitionFrame'),
        children: [
          {
            path: '',
            name: 'competitions.show',
            component: () => import('../views/pages/Competition/ShowCompetition'),
          },
          {
            path: 'set-tee-times',
            name: 'competitions.set-tee-times',
            component: () => import('../views/pages/Competition/ShowCompetitionForSetTeeTimes'),
          },
          {
            path: 'set-scores',
            name: 'competitions.set-scores',
            component: () => import('../views/pages/Competition/ShowCompetitionForSetResult'),
          },
          {
            path: 'edit',
            name: 'competitions.edit',
            component: () => import('../views/pages/Competition/EditCompetition'),
            meta: {
              guards: { roles: ['admin', 'coach'] },
            },
          },
        ],
      },
    ],
  },

  /* CART */
  {
    path: '/cart',
    component: () => import('../libs/Router/components/InnerRouter'),
    meta: {
      guards: { roles: ['parent'] },
    },
    children: [
      {
        name: 'cart',
        path: '',
        component: () => import('../views/pages/Cart/ShowCart'),
      },
      {
        name: 'cart.success',
        path: 'success',
        component: () => import('../views/pages/Cart/ShowCartSuccessFeedback'),
      },
    ],
  },
  {
    name: 'cart.finalize',
    path: '/cart/finalize',
    component: () => import('../views/pages/Cart/FinalizePayment'),
    meta: {
      guards: { roles: ['parent'] },
      layout: 'renderless',
    },
  },

  /* PAYMENTS */
  {
    path: '/payments',
    component: () => import('../libs/Router/components/InnerRouter'),
    meta: {
      guards: { roles: ['admin', 'parent'] },
    },
    children: [
      {
        path: '',
        name: 'payments.list',
        component: () => import('../views/pages/Payment/ListPayments'),
      },
      {
        path: ':id',
        name: 'payments.show',
        component: () => import('../views/pages/Payment/ShowPayment'),
      },
    ],
  },

  /* HELP */
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/pages/Help/Help'),
  },

  /* SETTINGS */
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/pages/Settings/EditSettings'),
    meta: {
      guards: { roles: ['admin'] },
    },
  },

  logoutRoute,
  catchallToRootRoute,
];
